import { render } from "preact";
import { App } from "./app";
import { InstallerApi } from "./cloud/api";
import { DevBearerAuth, takeTokenFromFragment } from "./cloud/auth";
import { WebUsbDeviceProvider } from "./flow/device-provider";
import { FlowStore, initialState, loadState } from "./flow/machine";
import { InstallRunner } from "./flow/runner";
import { detectLocale, setLocale } from "./i18n";
import { IdbChunkCache } from "./images/download";
import { trustedKeys } from "./images/release-keys";
import { RingLogger, newSessionId } from "./logs/ring";

/** Cloud base URL: build-time env, else same-origin `/api` (install.quickhub.ai proxies to voice.quickhub.ai). */
const API_BASE = (import.meta.env["VITE_QH_API_BASE"] as string | undefined) ?? `${location.origin}/api`;

const persisted = loadState(localStorage);
const sessionId = persisted?.sessionId ?? newSessionId();
const log = new RingLogger(sessionId);
const store = new FlowStore(persisted ?? initialState(sessionId), localStorage);
const auth = new DevBearerAuth(sessionStorage);
// Opened from the QuickHub portal: signed in for that business already.
const fromPortal = takeTokenFromFragment(auth, location, history);
const api = new InstallerApi({ baseUrl: API_BASE, auth });
// Dev release key only on the dev server or a lab build (VITE_QH_ALLOW_DEV_KEYS=true); production builds trust production keys only.
const ALLOW_DEV_KEYS = import.meta.env.DEV || import.meta.env["VITE_QH_ALLOW_DEV_KEYS"] === "true";
const runner = new InstallRunner({ store, api, keys: trustedKeys(ALLOW_DEV_KEYS), cache: new IdbChunkCache(), log, devices: new WebUsbDeviceProvider() });

setLocale(detectLocale(location.search, localStorage.getItem("qh-installer:lang"), navigator.language));
log.info("app.start", { resumed: persisted !== undefined, step: store.state.step, ua: navigator.userAgent, from_portal: fromPortal });
window.addEventListener("error", (e) => log.error("window.error", { message: e.message, source: e.filename, line: e.lineno }));
window.addEventListener("unhandledrejection", (e) => log.error("window.unhandledrejection", { reason: e.reason instanceof Error ? e.reason.message : String(e.reason) }));

render(<App runner={runner} log={log} />, document.getElementById("app")!);
